/**
 * Experiment to enable brand exclusivity agreements
 */
export const ENABLE_BRAND_EXCLUSIVITY_AGREEMENTS_230803 =
  'ENABLE_BRAND_EXCLUSIVITY_AGREEMENTS_230803';
